// Module
var code = "<sma-dialog title=\"¿QUIERES VENDER TU AUTO?\" show=\"0\"> <div slot=\"dialog_pre_title\"> <div class=\"logo\"> <img title=\"Logo\" class=\"logo-img\" width=\"200\" style=\"width:200px\"/> </div> </div> <div slot=\"dialog_content\"> <sma-cotizador id=\"cotizador\"></sma-cotizador> </div> </sma-dialog> ";
// Exports
module.exports = code;